module.exports = __webpack_public_path__ + "img/xiexuexiangbao.61476193.png";